import React from 'react';
import { RowWrapper } from './Row.style';

interface RowProps<T extends boolean> {
  // Space between different rows in px
  verticalSpacing: number | { mobile: number; tablet: number; desktop: number };
  fullWidth?: T | { mobile: boolean; tablet: boolean; desktop: T };
  // Max width of the row on desktop, default to be 100%
  maxWidth?: T extends true ? undefined : number;
  children: React.ReactNode;
  dataTest?: string;
}

const Row = <T extends boolean>({
  children,
  verticalSpacing,
  fullWidth = false as T,
  maxWidth,
  dataTest,
}: RowProps<T>) => {
  const spacings =
    typeof verticalSpacing === 'number'
      ? {
          desktop: verticalSpacing,
          tablet: verticalSpacing,
          mobile: verticalSpacing,
        }
      : verticalSpacing;
  const fullWidthSettings =
    typeof fullWidth === 'boolean'
      ? {
          desktop: fullWidth,
          tablet: fullWidth,
          mobile: fullWidth,
        }
      : fullWidth;
  return (
    <RowWrapper
      verticalSpacing={spacings}
      fullWidth={fullWidthSettings}
      maxWidth={maxWidth}
      data-test={dataTest}
    >
      {children}
    </RowWrapper>
  );
};

export default Row;
